module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene-list"
  }, [_c('ul', _vm._l((_vm.sceneList[0].itemList), function(item, index) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": '/' + _vm.lan + '/scene/1/' + item.id
      }
    }, [_c('img', {
      attrs: {
        "src": item.logoUrl
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.title))])])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67bb63b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/SceneList.vue
// module id = 720
// module chunks = 4